module.exports = __webpack_public_path__ + "static/ui-web-0fa2bef2a661b7979d91d2ea11b8bee3.png";